import { COMPANY_NAME } from '../constants';
import createQueryConfig, { NotFoundError } from '../queries';

export async function fetchMerchantPaymentSettings({
  merchantId,
  featureToggles,
  apiClient,
  queryClient,
}) {
  try {
    const queryConfig = createQueryConfig(queryClient, apiClient);
    const { queryKey, queryFn } = queryConfig.merchantPaymentSettingsV2({
      merchantId,
    });
    const response = await queryClient.fetchQuery({ queryKey, queryFn });
    const isPayPalFeatureToggleEnabled =
      featureToggles?.paypal_payment_enabled || false;

    const paymentMethods =
      response.payment_methods.filter(({ name, status }) => {
        // Remove PayPal payment method if PayPal feature toggle is disabled
        if (!isPayPalFeatureToggleEnabled && name === 'paypal') {
          return false;
        }
        if (COMPANY_NAME !== 'shore' && name === 'shorepay_online') {
          return false;
        }
        if (name === 'stripe' && status === 'not_setup') {
          return false;
        }
        return true;
      }) || [];

    return {
      payment_methods: paymentMethods,
    };
  } catch (error) {
    if (error instanceof NotFoundError) {
      return null;
    }

    throw error;
  }
}
